module.exports = __webpack_public_path__ + "img/inactive.7b573b1f.svg";